module.exports = __webpack_public_path__ + "img/WinterWyvern.b06deafd.png";